import { render } from "./MmFlashMessage.vue?vue&type=template&id=00397c40"
import script from "./MmFlashMessage.vue?vue&type=script&lang=js"
export * from "./MmFlashMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__